import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
            aria-label="五一吃瓜网首页"
          >
            <span
              className={`text-xl md:text-2xl font-bold font-heading whitespace-nowrap ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            >
              五一吃瓜网
            </span>
            <span
              className={`hidden sm:inline-block text-xs px-2 py-0.5 rounded-full font-medium ${
                scrolled || !isHome
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-accent-500 text-background-50'
              }`}
            >
              不打烊
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-accent-500 whitespace-nowrap ${
                location.pathname === '/' ? 'text-accent-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-100'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors hover:text-accent-500 whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}` ? 'text-accent-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors hover:text-accent-500 whitespace-nowrap ${
                location.pathname === '/about' ? 'text-accent-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i
              className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}
            />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              className={`block text-sm font-medium py-2 ${
                location.pathname === '/' ? 'text-accent-500' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`block text-sm font-medium py-2 ${
                  location.pathname === `/category/${cat.slug}` ? 'text-accent-500' : 'text-foreground-700'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`block text-sm font-medium py-2 ${
                location.pathname === '/about' ? 'text-accent-500' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}